<motif-theme variant='light'></motif-theme>
<app-mainframe>
  <app-page>
    <router-outlet></router-outlet>
  </app-page>
</app-mainframe>
